"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.JsonEditor = JsonEditor;
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _react = _interopRequireWildcard(require("react"));
var _vanillaJsoneditor = require("vanilla-jsoneditor");
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "json_editor-module__container___X0FiT",
  "title": "json_editor-module__title___fbs79",
  "readonly": "json_editor-module__readonly___hJGQQ",
  "cm-gutterElement": "json_editor-module__cm-gutterElement___B_Tua",
  "button": "json_editor-module__button___XzyNl",
  "maximize": "json_editor-module__maximize___CtErq",
  "minimize": "json_editor-module__minimize___k3Aoa",
  "beautify": "json_editor-module__beautify___ZPRyE",
  "redo": "json_editor-module__redo___Fn3G8",
  "undo": "json_editor-module__undo___P4C3r"
};
const EDITOR_MODE_TEXT = 'text';
const READ_ONLY_MODE_TREE = 'tree';
function JsonEditor(props) {
  const refContainer = (0, _react.useRef)(null);
  const refEditor = (0, _react.useRef)(null);
  const [maximized, toggleMaximized] = (0, _react.useState)(Boolean(props.maximized));
  const default_props = {
    mode: EDITOR_MODE_TEXT,
    navigationBar: false,
    indentation: 2,
    defaultExpand: true
  };
  const onRenderMenu = originalItems => {
    if (props.readOnly) return [];
    const title = {
      text: props.title,
      className: styles.title,
      disabled: true,
      onClick: _constants.NOOP
    };
    const undoButton = {
      ...((0, _find.default)(originalItems).call(originalItems, i => i.className === 'jse-undo') ?? {}),
      text: props.intl.formatMessage({
        id: 'au.jsonEditor.undo'
      }),
      className: styles.undo,
      icon: undefined
    };
    const redoButton = {
      ...((0, _find.default)(originalItems).call(originalItems, i => i.className === 'jse-redo') ?? {}),
      text: props.intl.formatMessage({
        id: 'au.jsonEditor.redo'
      }),
      className: styles.redo,
      icon: undefined
    };
    const formatButton = {
      ...((0, _find.default)(originalItems).call(originalItems, i => i.className === 'jse-format') ?? {}),
      text: props.intl.formatMessage({
        id: 'au.jsonEditor.beautify'
      }),
      className: styles.beautify,
      icon: undefined
    };
    const toggleButton = {
      text: props.intl.formatMessage({
        id: `au.jsonEditor.${maximized ? 'minimize' : 'maximize'}`
      }),
      onClick: () => {
        toggleMaximized(!maximized);
      },
      className: (0, _classnames.default)({
        [styles.maximize]: !maximized,
        [styles.minimize]: maximized
      })
    };
    return [Boolean(props.title) && title || {
      type: 'space'
    }, {
      type: 'space'
    }, undoButton, redoButton, formatButton, toggleButton];
  };
  if (props.readOnly) {
    default_props.mode = READ_ONLY_MODE_TREE;
    default_props.navigationBar = true;
  }
  const editorProps = {
    ...default_props,
    content: props.content,
    readOnly: props.readOnly,
    onChange: props.onChange,
    defaultExpand: props.defaultExpand,
    onRenderMenu
  };
  (0, _react.useEffect)(() => {
    if (maximized && props.onMaximize) {
      props.onMaximize();
    } else if (props.onMinimize) {
      props.onMinimize();
    }
  }, [maximized]);
  (0, _react.useEffect)(() => {
    // create editor
    refEditor.current = new _vanillaJsoneditor.JSONEditor({
      target: refContainer.current,
      props: editorProps
    });

    // default expand only 3 levels and collapse rest to make rendering quick
    if (props.defaultExpand) {
      refEditor.current.expand(path => path.length < 3);
    }
    return () => {
      // destroy editor
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, []);

  // update props
  (0, _react.useEffect)(() => {
    refEditor.current?.updateProps(editorProps);
  }, [props, maximized]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.container, props.className, {
      [styles.readonly]: props.readOnly
    }),
    ref: refContainer
  });
}
JsonEditor.propTypes = {
  title: T.string,
  content: T.shape({
    json: T.object,
    text: T.string
  }).isRequired,
  className: T.string,
  maximized: T.bool,
  readOnly: T.bool,
  onMaximize: T.func,
  onMinimize: T.func,
  onChange: T.func,
  defaultExpand: T.bool
};
var _default = exports.default = (0, _reactIntl.injectIntl)(JsonEditor);